import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './abastecimentoForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { sortData } from '../common/table/sortHelper';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getOpcoes
} from './abastecimentoActions';

const columns = [
    { field: 'datahora_abastecimento', type: 'date' },
    { field: 'nome_veiculo', type: 'text' },
    { field: 'origem', type: 'text' },
    { field: 'nome_fornecedor', type: 'text' },
    { field: 'nome_usuario', type: 'text' },
    { field: 'quantidade', type: 'number' },
    { field: 'valor_total', type: 'number' }
];

const formatarMoeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const Abastecimento = props => {
    const [linhaSelecionada, setLinhaSelecionada] =
        useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'datahora_abastecimento',
        direction: 'desc'
    });

    useEffect(() => {
        props.getLista();
        props.getOpcoes();
    }, []);

    const onSort = field => {
        setSort(anterior => ({
            field,
            direction:
                anterior.field === field &&
                anterior.direction === 'asc'
                    ? 'desc'
                    : 'asc'
        }));
    };

    const filtrar = () => {
        const termo = (pesquisar || '').trim().toUpperCase();

        const listaFiltrada = (props.lista || []).filter(item => {
            if (!termo) {
                return true;
            }

            return [
                item.nome_veiculo,
                item.origem,
                item.nome_fornecedor,
                item.nome_usuario,
                item.numero_nf,
                item.observacao
            ].join(' ').toUpperCase().includes(termo);
        });

        return sortData(listaFiltrada, sort, columns);
    };

    const abrir = (modo, item) => {
        props.setModoTela(modo, item);
        props.initForm(item);
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item,
                    datahora_formatada:
                        getDataHoraFormatada(
                            item.datahora_abastecimento
                        ),
                    origem_formatada:
                        item.origem === 'POSTO'
                            ? 'Posto'
                            : 'Interno',
                    valor_total_formatado:
                        formatarMoeda(item.valor_total)
                }))}
                name='Abastecimentos'
            >
                <ExcelColumn
                    label='Data / Hora'
                    value='datahora_formatada'
                />
                <ExcelColumn
                    label='Veículo'
                    value='nome_veiculo'
                />
                <ExcelColumn
                    label='Origem'
                    value='origem_formatada'
                />
                <ExcelColumn
                    label='Fornecedor'
                    value='nome_fornecedor'
                />
                <ExcelColumn
                    label='Responsável'
                    value='nome_usuario'
                />
                <ExcelColumn label='Litros' value='quantidade' />
                <ExcelColumn
                    label='Valor total'
                    value='valor_total_formatado'
                />
                <ExcelColumn label='Odômetro' value='odometro' />
                <ExcelColumn label='Horímetro' value='horimetro' />
                <ExcelColumn label='Número NF' value='numero_nf' />
                <ExcelColumn
                    label='Observação'
                    value='observacao'
                />
            </ExcelSheet>
        );
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();
        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 260
            : window.innerHeight - 180;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={setPesquisar}
                        />

                        <div style={{ marginTop: 8, width: 270 }}>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{
                                    marginLeft: 2,
                                    minWidth: 75
                                }}
                                onClick={() => abrir('cadastro', {})}
                            >
                                <i className='fas fa-plus' />
                                Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{
                                    marginLeft: 2,
                                    minWidth: 75
                                }}
                                onClick={() => {
                                    props.getLista();
                                    props.getOpcoes();
                                }}
                            >
                                <i className='fas fa-sync-alt' />
                                Atualizar
                            </button>

                            <ExcelFile
                                filename='Abastecimentos'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{
                                            marginLeft: 2,
                                            minWidth: 75
                                        }}
                                    >
                                        <i className='fas fa-file-excel' />
                                        Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='datahora_abastecimento'
                                    label='Data / Hora'
                                    width={150}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='nome_veiculo'
                                    label='Veículo'
                                    width={180}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='origem'
                                    label='Origem'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='nome_fornecedor'
                                    label='Fornecedor'
                                    width={220}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='nome_usuario'
                                    label='Responsável'
                                    width={180}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='quantidade'
                                    label='Litros'
                                    width={90}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <ThSort
                                    field='valor_total'
                                    label='Valor total'
                                    width={120}
                                    sort={sort}
                                    onSort={onSort}
                                />
                                <Th sticky alignCenter width={80} />
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, index) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : index % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {getDataHoraFormatada(
                                            item.datahora_abastecimento
                                        )}
                                    </Td>
                                    <Td alignCenter>{item.nome_veiculo}</Td>
                                    <Td alignCenter>
                                        {item.origem === 'POSTO'
                                            ? 'Posto'
                                            : 'Interno'}
                                    </Td>
                                    <Td alignCenter>
                                        {item.nome_fornecedor || '-'}
                                    </Td>
                                    <Td alignCenter>{item.nome_usuario}</Td>
                                    <Td alignCenter>
                                        {FormatUtils.formatarValorTela(
                                            item.quantidade,
                                            3
                                        )}
                                    </Td>
                                    <Td alignCenter>
                                        {formatarMoeda(item.valor_total)}
                                    </Td>
                                    <Td
                                        alignCenter
                                        minWidth={90}
                                        maxWidth={90}
                                    >
                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible={true}
                                            title='Editar'
                                            event={() =>
                                                abrir('cadastro', item)
                                            }
                                        />
                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible={true}
                                            title='Excluir'
                                            event={() =>
                                                abrir('exclusao', item)
                                            }
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' && renderLista()}
        </Content>
    );
};

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.abastecimento.modoTela,
    aguardando: state.abastecimento.aguardando,
    lista: state.abastecimento.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getOpcoes
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Abastecimento);
